import { FACEBOOK_SDK_CONFIG, FB_SDK_INIT_TIMEOUT_MS } from './config';

export const setupFacebookSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof globalThis !== 'undefined' && globalThis.FB) {
      try {
        globalThis.FB.init(FACEBOOK_SDK_CONFIG);
        resolve();

        return;
      } catch (error) {
        reject(error);

        return;
      }
    }

    globalThis.fbAsyncInit = () => {
      try {
        globalThis.FB.init(FACEBOOK_SDK_CONFIG);
        resolve();
      } catch (error) {
        reject(new Error(`Failed to initialize Facebook SDK: ${error}`));
      }
    };

    const timeoutId = setTimeout(() => {
      reject(
        new Error(
          `Facebook SDK initialization timeout (${FB_SDK_INIT_TIMEOUT_MS}ms)`
        )
      );
    }, FB_SDK_INIT_TIMEOUT_MS);

    if (globalThis.FB) {
      clearTimeout(timeoutId);
      try {
        globalThis.FB.init(FACEBOOK_SDK_CONFIG);
        resolve();
      } catch (error) {
        reject(error);
      }
    }
  });
};
